import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import '../css/Sidebar.css';

const DEFAULT_LINKS = [
  {
    label: 'Payments',
    to: '/payments',
    iconClass: 'bi-cash-coin',
  },
  {
    label: 'Settings',
    to: '/settings',
    iconClass: 'bi-gear',
  },
  {
    label: 'Log Out',
    to: '/logout',
    iconClass: 'bi-box-arrow-right',
  },
];

const NAVIGATION_KEYS = new Set(['ArrowDown', 'ArrowUp', 'Home', 'End']);

const Sidebar = ({
  links = DEFAULT_LINKS,
  ariaLabel = 'Portal navigation',
  className = '',
}) => {
  const linkRefs = useRef([]);

  const handleNavigationKeyDown = (event) => {
    if (!NAVIGATION_KEYS.has(event.key)) {
      return;
    }

    const linksCount = links.length;
    if (!linksCount) {
      return;
    }

    const currentIndex = linkRefs.current.findIndex((item) => item === document.activeElement);
    let nextIndex = currentIndex;

    if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = linksCount - 1;
    } else if (event.key === 'ArrowDown') {
      nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % linksCount;
    } else if (event.key === 'ArrowUp') {
      nextIndex = currentIndex < 0 ? linksCount - 1 : (currentIndex - 1 + linksCount) % linksCount;
    }

    const nextLink = linkRefs.current[nextIndex];
    if (nextLink) {
      event.preventDefault();
      nextLink.focus();
    }
  };

  const sidebarClasses = ['portal-sidebar', className]
    .filter(Boolean)
    .join(' ');

  return (
    <aside className={sidebarClasses}>
      <div className='portal-sidebar-header'>
        <h2 className='portal-sidebar-title'>Menu</h2>
      </div>

      <nav id='portal-sidebar-nav' className='portal-sidebar-nav' aria-label={ariaLabel} onKeyDown={handleNavigationKeyDown}>
        {links.map((link, index) => {
          const key = `${link.to || link.href || link.action || index}-${link.label}`;
          const commonProps = {
            className: 'portal-sidebar-link',
          };

          const content = (
            <>
              <span className='portal-sidebar-icon' aria-hidden='true'>
                <i className={`bi ${link.iconClass}`}></i>
              </span>
              <span className='portal-sidebar-label'>{link.label}</span>
            </>
          );

          if (link.external && link.href) {
            return (
              <a
                key={key}
                href={link.href}
                target='_blank'
                rel='noreferrer'
                {...commonProps}
                ref={(element) => {
                  linkRefs.current[index] = element;
                }}
              >
                {content}
              </a>
            );
          }

          if (typeof link.onClick === 'function' && !link.to) {
            return (
              <a
                key={key}
                href={link.href || '#'}
                onClick={link.onClick}
                {...commonProps}
                ref={(element) => {
                  linkRefs.current[index] = element;
                }}
              >
                {content}
              </a>
            );
          }

          return (
            <NavLink
              key={key}
              to={link.to}
              exact={Boolean(link.exact)}
              activeClassName='is-active'
              {...commonProps}
              innerRef={(element) => {
                linkRefs.current[index] = element;
              }}
            >
              {content}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
